import { makeStyles } from '@material-ui/core/styles';

export const makeDashboardPageStyles = makeStyles((theme) => ({
  dashboard__master: { background: theme.colorBox },
  dashboard__detail: { background: theme.palette.background.default },
  hr: { 'border-color': theme.colorSeperator },
}));
